<template>
    <transition name="modal">
        <div id="addTalkgroupToUser" class="dialog-modal-mask">
            <div class="large-panel" @click.stop>
                <div class="dialog-title">
                    <div v-t="{ path: 'message.assign_talkgroup_to_stt_extension_dictionary', args: { DICT: baseDictionaryInfo.name + ' ' } }">
                    </div>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body">
                    <table width=100% height=100% cellpadding=0 cellspacing=0>
                        <tr class="dialoginputfield">
                            <td colspan=2>
                                <div style="padding: 10px;">
                                    <el-form @submit.native.prevent="findGroup()">
                                        <el-radio-group style="padding-left:10px" v-model="listType" fill="#5171cb">
                                            <el-radio-button :label="0"><span v-t="'message.action_select_by_list'"/></el-radio-button>
                                            <el-radio-button :label="1"><span v-t="'message.action_select_by_search'"/></el-radio-button>
                                        </el-radio-group>
                                        <el-input v-if="listType === 1" :placeholder="$t('message.place_holder_input_text')" v-model.trim="searchString" clearable class="object-search-select">
                                            <el-select v-model="condition" slot="prepend" :placeholder="$t('message.place_holder_search_condition')" class="search-item">
                                                <el-option :label="$t('message.item_groupId')" value="groupId"></el-option>
                                                <el-option :label="$t('message.item_groupDisplayName')" value="groupName"></el-option>
                                            </el-select>
                                            <el-button slot="append" style="width: 100px;vertical-align:middle" native-type="submit" v-t="'message.action_search_items'"></el-button>
                                        </el-input>
                                    </el-form>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="dialog-td">
                                <div class="inner-panel-header">
                                    <div class="inner-panel-title">
                                        <div class="inner-panel-title-left" v-t="'message.title_select_group'">
                                        </div>
                                        <div v-if="listType === 1" class="inner-panel-title-right">
                                            <button class="transparent" @click="selectTagAll()" type="button"><span class="normal-command-text" v-t="'message.action_select_all'"></span></button>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="listType === 0" class="inner-panel-dialog" style="height: calc(80vh - 250px);">
                                    <dialogtree
                                        class="dialog-tree"
                                        v-bind:initialData="[rootNode]"
                                        @on-selectnode="handleOnSelectNode"
                                        selectionType=2
                                        ref="dialogTree">
                                    </dialogtree>
                                </div>
                                <div v-else class="inner-panel-dialog" style="height: calc(80vh - 250px);">
                                    <div class="foundObject-record" v-for="object in foundGroupList" @click="addTagWithConditionCheck(object.node.data)">
                                        <div class="foundObject">
                                            <span style="padding-left:10px;vertical-align:middle">{{ object.node.data.label }}</span>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="dialog-td">
                                <div class="inner-panel-header">
                                    <div class="inner-panel-title">
                                        <div class="inner-panel-title-left" v-t="'message.title_editing_group'">
                                        </div>
                                        <div class="inner-panel-title-right">
                                            <button class="transparent" @click="removeAllUserTag()" type="button"><span class="normal-command-text" v-t="'message.action_delete_all'"></span></button>
                                        </div>
                                    </div>
                                </div>
                                <div id="selected-user" class="inner-panel-dialog" style="height: calc(80vh - 250px);">
                                    <div class="selected-item-field">
                                        <div class="default-message" v-if="!Object.keys(editTagList).length" v-html="$t('message.hint_add_group_to_user')">
                                        </div>
                                        <span v-for="tag in editTagList" v-bind:key="tag.id">
                                            <div class="userTag">
                                                <span class="userTag-name">{{ tag.displayName }}</span>
                                                <span class="closeTag" @click="removeUserTag(tag)">×</span>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="disableSave" @click="saveUpdatedInfo()" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Vue from 'vue'
import server from "@/components/ServerApi.js";
import DialogTree from "../../../DialogTree.vue"
import commonUtil from '@/components/commonutil.js';
import constants from '@/components/constants.js';

const STATUS_SUCCESS = 0;
const STATUS_ALREADY_EXIST = -1;
const STATUS_UNMATCH_SPEECH_TO_TEXT = -2;
const STATUS_UNMATCH_DICTIONARY_ALREADY_ASSIGNED = -6;

export default {
    components: {
        dialogtree: DialogTree
    },

    props: {
        tenantId: {
            type: Number,
            required: true
        },
        baseDictionaryInfo: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            rootNode: {
                tenantId: this.tenantId,
                id: 1,
                label: "ROOT-NODE",
                type: 0,
                isLeaf: false
            },
            scrollOnAction: false,
            editTagList: {},
            orgTagList: {},
            addTagList: {},
            removeTagList: {},
            foundGroupList: [],
            listType: 0,
            condition: "groupId",
            searchString: null,
            disableSave: true,
        };
    },

    created: function() {
        this.disableSave = true;
        return this.getTalkGroupsBySttDictionary();
    },

    updated: function() {
        if (this.scrollOnAction) {
            let obj = document.getElementById("selected-user");
            obj.scrollTop = obj.scrollHeight;
            this.scrollOnAction = false;
        }
    },

    methods: {
        findGroup() {
            let param = {tenantId: this.tenantId}
            if (this.condition === "groupId") {
                param.name = this.searchString;
            } else if (this.condition === "groupName") {
                param.displayName = this.searchString;
            }
            let self = this;
            server.post("/findgroup", param)
            .then((res) => {
                if (res.data.status === constants.STATUS_SUCCESS) {
                    if (res.data.groupInfo.length === 0) {
                        self.foundGroupList = [];
                        commonUtil.notifyMessage(self,"Info",commonUtil.getMessageText(self.$i18n,"info_group_not_found").replace('{object}',commonUtil.getMessageText(self.$i18n,"item_group")));
                        return;
                    }
                } else {
                    self.foundGroupList = [];
                    commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","findGroup").replace("{code}",res.data.status));
                    return;
                }
                self.foundGroupList = [];
                for (let objectInfo of res.data.groupInfo) {
                    let object = { node : { data: null, parent: { data: null} } }
                    object.node.data = {
                        id: self.tenantId + "-" + objectInfo.id,
                        tenantId: self.tenantId,
                        type: constants.OBJECT_TALKGROUP,
                        talkgroupId: objectInfo.id,
                        talkgroupName: objectInfo.name ,
                        displayName: objectInfo.displayName,
                        optionFlag: objectInfo.optionFlag,
                        label: objectInfo.name,
                        dictionaryId: objectInfo.dictionaryId,
                    };
                    object.node.parent.data = {id: objectInfo.pid}
                    self.foundGroupList.push(object);
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "findGroup", error);
                self.foundGroupList = [];
            });
        },
        getTalkGroupsBySttDictionary() {
            this.$nextTick(this.fetchTalkGroupsBySttDictionary);
        },
        fetchTalkGroupsBySttDictionary() {
            let loadingScreen = this.$loading({
                    lock: true ,
                    text: 'Loading data ...' ,
                    spinner: 'el-icon-loading' ,
                    background: 'rgba(0, 0, 0, 0)'
            });

            let self = this;
            server.post('/gettalkgroupsbysttdictionary', {dictionaryId: this.baseDictionaryInfo.id})
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            break;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_already_changed"));
                            return;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getTalkGroupsBySttDictionary").replace("{code}",res.data.status));
                            return;
                    }
                    for (let talkgroupInfo of res.data.talkgroups) {
                        let key = this.tenantId + "-" + talkgroupInfo.talkgroupId;
                        let tagInfo = {
                            id: key,
                            tenantId: this.tenantId,
                            type: constants.OBJECT_TALKGROUP,
                            talkgroupId: talkgroupInfo.talkgroupId,
                            talkgroupName: talkgroupInfo.talkgroupName,
                            displayName: talkgroupInfo.displayName,
                            label: talkgroupInfo.talkgroupName,
                            dictionaryId: self.baseDictionaryInfo.id,
                        };
                        Vue.set(self.editTagList, key, tagInfo);
                        Vue.set(self.orgTagList, key, tagInfo);
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "getTalkGroupsBySttDictionary", error);
                })
                .finally(() => {
                    loadingScreen.close();
                });
        },
        selectTagAll() {
            let addGroupCount = 0;
            for (let groupNode of this.foundGroupList) {
                let tagInfo = groupNode.node.data;
                if (this.checkConditionToAdd(tagInfo) === STATUS_SUCCESS) {
                    this.addTag(tagInfo)
                    addGroupCount ++;
                }
            }
            if (addGroupCount !== this.foundGroupList.length) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_add_all_object").replace("{object}",commonUtil.getMessageText(this.$i18n,"item_group")));
            }
        },
        addTagWithConditionCheck(tagInfo) {
            switch(this.checkConditionToAdd(tagInfo)) {
                case STATUS_SUCCESS:
                    this.addTag(tagInfo);
                    break;
                case STATUS_ALREADY_EXIST:
                    commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_group_already_added"));
                    break;
                case STATUS_UNMATCH_SPEECH_TO_TEXT:
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_add_group_no_speechText"));
                    break;
                case STATUS_UNMATCH_DICTIONARY_ALREADY_ASSIGNED:
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_add_group_stt_extension_dictionary_already_assigned"));
                    break;
            }
        },
        addTag(tagInfo) {
            this.scrollOnAction = true;
            Vue.set(this.editTagList, tagInfo.id , tagInfo);
            Vue.delete(this.removeTagList, tagInfo.id);
            if (!(tagInfo.id in this.orgTagList)) {
                Vue.set(this.addTagList, tagInfo.id, tagInfo);
            }
            this.disableSave = false;
            return true;
        },
        checkConditionToAdd(tagInfo) {
            if (tagInfo.id in this.editTagList) {
                return STATUS_ALREADY_EXIST;
            }
            if ((tagInfo.optionFlag & (1 << constants.TALKGROUP_OPTION_SPEECH_TEXT)) === 0) {
                return STATUS_UNMATCH_SPEECH_TO_TEXT;
            }
            if (tagInfo.dictionaryId > 0 && !(tagInfo.id in this.orgTagList)) {
                return STATUS_UNMATCH_DICTIONARY_ALREADY_ASSIGNED;
            }
            return STATUS_SUCCESS;
        },
        handleOnSelectNode(data,node) {
            if (data.type === constants.OBJECT_TALKGROUP) {
                let key = data.tenantId + "-" + data.id;
                if ((key in this.editTagList)) {
                    commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_group_already_added"));
                    return;
                }
            } else {
                return;
            }

            let self = this;
            let tenantId = data.tenantId;
            let talkgroupId = data.id;
            server.post('/getinfo', {tenantId: tenantId, id: talkgroupId})
                .then((res) => {
                    if (res.data.status >= 0) {
                        let tagInfo = {
                            id: tenantId + '-' + talkgroupId,
                            tenantId: tenantId,
                            type: constants.OBJECT_TALKGROUP,
                            talkgroupId: res.data.id ,
                            talkgroupName: res.data.name ,
                            displayName: res.data.displayName,
                            optionFlag: res.data.optionFlag,
                            label: res.data.name,
                            dictionaryId: res.data.dictionaryId,
                        };
                        this.addTagWithConditionCheck(tagInfo);
                    } else {
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","handleOnSelectNode").replace("{code}",res.data.status));
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "handleOnSelectNode", error);
                });
        },
        removeUserTag(tag) {
            if ((tag.id in this.orgTagList)) {
                Vue.set(this.removeTagList, tag.id, tag);
            }
            Vue.delete(this.addTagList, tag.id);
            Vue.delete(this.editTagList, tag.id)
            this.disableSave = false;
        },
        removeAllUserTag() {
            for (let key in this.editTagList) {
                if ((key in this.orgTagList)) {
                    Vue.set(this.removeTagList, key, this.editTagList[key]);
                }
            }
            this.editTagList = {};
            this.addTagList = {};
            this.disableSave = false;
        },
        saveUpdatedInfo() {
            this.$emit('save' , { removeTagList: this.removeTagList , addTagList: this.addTagList });
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-select-dropdown__item {
    font-size: 12px;
}
.el-select-dropdown__item selected {
    color: #5171cb;
}
.dialog-tree >>> .el-tree-node__content {
    min-height: 40px !important;
    height: auto !important;
    white-space: normal !important;
    word-break: break-all !important;
    text-align: justify;
}
.dialog-tree >>>.el-tree-node__expand-icon {
    padding: 0px 28px !important;
}

</style>

